import {useState} from 'react'

// import profile from '../assets/profile.svg';
import profile2 from '../assets/profile.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import {faCircleArrowRight, } from "@fortawesome/free-solid-svg-icons";
import {faWhatsapp,  faGithub, faInstagram, faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
import hr from '../assets/curve-hr.svg'

export default function Hiro () {

    const [loaded, setLoaded] = useState(true);

    return (
        <>
        {loaded ?
        <div
            className="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-white flex flex-col items-center justify-center"
        >Loading...</div>
            :
            null
        }
        <div id="home" className="flex w-full h-screen flex-col md:flex-row gap-5 items-center justify-center text-white relative">
            <div className='md:w-3/6 md:p-4'>
                <img data-aos="flip-right" data-aos-duration="1500" data-aos-offset="200"  src={profile2} alt="profile" onLoad={() => setLoaded(false)} />
            </div>
            <div className='md:w-3/6' data-aos="fade-right" data-aos-duration="1000" data-aos-offset="100" >
                <div className="flex flex-col w-full mt-8">
                    <h1 className="text-xl text-gray-400">Olá, mundo !</h1>
                    <h1 className="text-2xl font-bold">Jhonatan Magalhães do Vale</h1>
                    <p class="text-xl font-bold text-gray-300">QA Engineer</p>
                    <p className="text-md font-light text-gray-400 ">
"Com uma carreira consolidada de 5 anos como QA Engineer e experiência prévia em infraestrutura, sou um profissional apaixonado por tecnologia e comprometido em garantir a qualidade de produtos e serviços. Possuo habilidades técnicas avançadas em testes de software, automação e metodologias ágeis, sempre buscando aprimorar meus conhecimentos para entregar resultados eficientes e impactantes para o negócio."</p>
                </div>
                <a href='https://api.whatsapp.com/send?phone=5566997218952&text=Ol%C3%A1,%20encontrei%20seu%20CV%20atrav%C3%A9z%20do%20seu%20Portf%C3%B3lio.' className='mt-2 block'>Entre em contato via whatsapp: <FontAwesomeIcon className='ml-2' icon={faWhatsapp}/> </a>

                <ul className='flex mt-2 gap-4 items-center'>
                   <li>
                        <a href='https://github.com/jhonjhon95' rel="noreferrer" target="_blank"><FontAwesomeIcon size='2xl' icon={faGithub} /></a>
                   </li> 
                    <li>
                        <a href='https://instagram.com/jhon_jhon95/' rel="noreferrer" target="_blank"><FontAwesomeIcon size='2xl' icon={faInstagram} /></a>
                    </li>
                    <li>
                        <a href='https://linkedin.com/in/jjhon' rel="noreferrer" target="_blank"><FontAwesomeIcon size='2xl' icon={faLinkedinIn} /></a>
                    </li>
                </ul>
            </div>
            <img src={hr} className="w-full md:h-2 absolute bottom-0" alt="hr" />
        </div>
        </>
    )
}
